import { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledTable, TableContainer } from './styles';

type TableProps = Readonly<{
  columns: ReadonlyArray<{
    name: string;
    value: string;
    accessor?: string;
    render?: (row: any) => ReactNode;
    maxWidth?: string | number;
  }>;
  data: ReadonlyArray<any>;
  disabled?: boolean;
}>;

export function SimpleTable({ columns, data, disabled }: TableProps): ReactElement {
  const { t } = useTranslation();

  return (
    <TableContainer>
      <StyledTable disabled={disabled}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th
                key={col.name}
                style={{
                  maxWidth: col.maxWidth,
                }}
              >
                {col.value}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((row, i) => (
              <tr key={i}>
                {columns.map((col) => (
                  <td
                    key={col.name}
                    style={{
                      maxWidth: col.maxWidth,
                    }}
                  >
                    {(() => {
                      let cellContent: ReactNode;

                      if (col.render) {
                        cellContent = col.render(row);
                      } else if (col.accessor) {
                        cellContent = row[col.accessor];
                      } else {
                        cellContent = null;
                      }

                      return cellContent;
                    })()}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: 'center', padding: '16px' }}>
                {t('nenhumDadoEncontrado')}
              </td>
            </tr>
          )}
        </tbody>
      </StyledTable>
    </TableContainer>
  );
}
